import React, {useEffect} from "react";
import { Trans, useTranslation} from 'react-i18next';
import AOS from 'aos';
import "./aosProfileInt.css"
import 'aos/dist/aos.css';
import SantaPortrait from "../../assets/Int/Santaportrait.jpg"
import ImageLeft from "../../assets/Int/2CARR.JPG"


export default function AosProfileInt() {
    useEffect(() => {
        AOS.init();
      }, [])
  
    return (
        <div className="profilecontainer">
          <p className="titlediv" 
              data-aos="zoom-out"
              data-aos-offset="300"
              data-aos-once="true"
              data-aos-duration="1000">
            <Trans i18nKey="description.titleprofile"/>
          </p>
          <img
            src="https://svgsilh.com/svg/2024359.svg"
            className='imgbg2'
            data-aos="zoom-out"
            data-aos-offset="300"
            data-aos-once="true"
            data-aos-duration="2000"
          />
          <div className="profiledivimg">
            <div className="profiledivright">
              <img
                src={SantaPortrait}
                className="profileimg"
                data-aos="zoom-out"
                data-aos-offset="300"
                data-aos-once="true"
                data-aos-duration="2000">
              </img>
              <p className="titleimgright"
                  data-aos="zoom-out"
                  data-aos-offset="100"
                  data-aos-once="true"
                  data-aos-duration="2000">[<Trans i18nKey="description.titletextprofile"></Trans>]</p>
              <p className="textimgright"
                  data-aos="zoom-out"
                  data-aos-offset="100"
                  data-aos-once="true"
                  data-aos-duration="2000">
              <Trans i18nKey="description.textprofile"></Trans></p>
            </div>
            <div className="profiledivleft">
              <img
                src={ImageLeft}
                className="profileimgleft" 
                data-aos="zoom-out"
                data-aos-offset="300"
                data-aos-once="true"
                data-aos-duration="2000">
              </img>
              <p className="titleimgleft"
               data-aos="zoom-out"
               data-aos-offset="100"
               data-aos-once="true"
               data-aos-duration="2000">[<Trans i18nKey="description.titletextprofile"></Trans>]</p>
              <p className="textimgleft"
                  data-aos="zoom-out"
                  data-aos-offset="100"
                  data-aos-once="true"
                  data-aos-duration="2000">
              <Trans i18nKey="description.textprofile"></Trans></p>
            </div>
          </div>
      </div>
        );
}